// Default search values for filtering carts
export const searchValues = {
  toDate: "",
  fromDate: "",
  toAmount: "",
  fromAmount: "",
  projectTitle: "",
  classificationId: "",
  isRecentPaymentExists: true,
};

// Mapping of Excel header names to their corresponding field names in the data
export const excelHeaderCellsName = {
  "المعرف": "id",
  "اسم المتبرع": "donorName",
  "عدد العناصر": "itemCount",
  "رقم الهاتف": "phoneNumber",
  "تاريخ الإنشاء": "createdOn",
  "السعر الإجمالي": "totalPrice",
  "المشاريع": "projectsTitles",
  "الاهداءات": "giftProjectsTitles",
  "التصنيفات": "classificationsTitles",
};

// Mapping of Excel header names to their corresponding field names for display purposes
export const excelHeaderCellsNameForShow = {
  "المعرف": "id",
  "الكمية": "quantity",
  "اسم المشروع": "projectName",
  "السعر الإجمالي": "totalPrice",
};
